import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Search, Wrench } from 'lucide-react';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 40
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function CuraSection() {
  return <section className="py-24 bg-pure-black relative border-t border-white/5" data-id="element-79">
      {/* Subtle background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-emerald-glow/5 rounded-full blur-[120px] pointer-events-none" data-id="element-80" />

      <div className="container mx-auto px-6 relative z-10" data-id="element-81">
        <div className="text-center mb-16" data-id="element-82">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-black text-electric-yellow mb-4 uppercase tracking-wide" data-id="element-83">
            La Cura
          </motion.h2>
          <motion.div initial={{
          opacity: 0,
          scaleX: 0
        }} whileInView={{
          opacity: 1,
          scaleX: 1
        }} viewport={{
          once: true
        }} className="h-1 w-24 bg-emerald-glow mx-auto rounded-full" data-id="element-84" />
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-85">
          {/* Card 1 */}
          <motion.div variants={itemVariants} className="bg-dark-gray rounded-xl p-8 border border-white/10 relative overflow-hidden group hover:border-emerald-glow/30 transition-colors duration-300" data-id="element-86">
            <div className="absolute top-0 left-0 w-full h-1 bg-emerald-glow opacity-50 group-hover:opacity-100 transition-opacity" data-id="element-87" />
            <div className="bg-pure-black w-14 h-14 rounded-full flex items-center justify-center mb-6 border border-white/10 group-hover:border-emerald-glow/50 transition-colors" data-id="element-88">
              <Search className="w-7 h-7 text-emerald-glow" data-id="element-89" />
            </div>
            <h3 className="text-2xl font-bold text-white mb-4" data-id="element-90">
              Local SEO Agresivo
            </h3>
            <p className="text-gray-400 leading-relaxed text-lg" data-id="element-91">
              Cuando alguien busque "Mecánico cerca de mí", tú eres la primera
              opción con 5 estrellas.
            </p>
          </motion.div>

          {/* Card 2 */}
          <motion.div variants={itemVariants} className="bg-dark-gray rounded-xl p-8 border border-white/10 relative overflow-hidden group hover:border-emerald-glow/30 transition-colors duration-300" data-id="element-92">
            <div className="absolute top-0 left-0 w-full h-1 bg-emerald-glow opacity-50 group-hover:opacity-100 transition-opacity" data-id="element-93" />
            <div className="bg-pure-black w-14 h-14 rounded-full flex items-center justify-center mb-6 border border-white/10 group-hover:border-emerald-glow/50 transition-colors" data-id="element-94">
              <Wrench className="w-7 h-7 text-emerald-glow" data-id="element-95" />
            </div>
            <h3 className="text-2xl font-bold text-white mb-4" data-id="element-96">
              Ofertas de Diagnóstico Digital
            </h3>
            <p className="text-gray-400 leading-relaxed text-lg" data-id="element-97">
              Atraemos al cliente con una revisión básica y cerramos la
              reparación mayor en el sitio.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}